import { computed, onMounted, ref } from 'vue'
import { t } from '@/i18n'
import { get, post } from '@/request'
import { userModel } from '@/model/user'
import $loading from '@/components/WiLoading'
import { toast } from '@/components/WiToast'
import { dialog } from '@/components/WiDialog'
import { useRoute, useRouter } from 'vue-router'

export function taskModel() {
    const { userInfoFunc } = userModel()
    const route = useRoute()
    const router = useRouter()

    let confirmShowRef = ref(false)
    let commentShowRef = ref(false)
    let isFromOrderRef = ref(false)
    let taskRef = ref({})

    let starValueRef = ref(0)
    let commentSelectRef = ref([])

    let progressTimer = undefined

    async function startTaskFunc() {
        $loading.show(t('正在寻找酒店'))
        const res = await post({url: '/task/v1/task/receive-task'})
        if (res.code == 200 && res.data) {
            progressTimer && clearTimeout(progressTimer)
            progressTimer = setTimeout(() => {
                progressTimer && clearTimeout(progressTimer)
                $loading.hide()
                taskRef.value = res.data
                userInfoFunc()
                confirmShowRef.value = true
            }, 1500 + parseInt(Math.random() * 1000))
        }else {
            $loading.hide()
            userInfoFunc()
            dialog({
                title: t('提示'),
                content: res.message,
                noCancel: true
            }).then(()=> {})
        }
    }
    async function submitTaskFunc(id, combo, params) {
        return new Promise(async (resolve) => {
            if (!id) {
                id = taskRef.value.order_id
                combo = taskRef.value.combo
            }
            let data = { id: id, ...params }
            let res = await post({url: '/task/v1/task/task-order-submit', data: data}, {loading: true})
            if(res.code != 200) {
                toast({
                    title: res.message,
                    type: 'error'
                })
                return
            }
            commentShowRef.value = false
            confirmShowRef.value = false
            if (combo) {
                startTaskFunc()
            }
            else {
                toast({
                    title: res.message,
                    type: 'success'
                })
            }
            userInfoFunc()
            resolve()
        })
    }

    return { confirmShowRef, commentShowRef, isFromOrderRef, taskRef, starValueRef, commentSelectRef, startTaskFunc, submitTaskFunc }
}

export function taskOrderModel(init) {
    let statusListRef = ref([
        {name: t('全部'), status: ''},
        {name: t('待处理'), status: 0},
        {name: t('冻结中'), status: 1},
        {name: t('已完成'), status: 2},
    ])
    let statusIndexRef = ref(0)
    let statusValueRef = computed(()=> {
        return statusListRef.value[statusIndexRef.value]&&statusListRef.value[statusIndexRef.value].status
    })
    let pageRef = ref(0)
    let pageSizeRef = ref(10)
    let hashLoadingRef = ref(false)
    let hashMoreRef = ref(false)
    let orderListRef = ref([])
    let orderDetailRef = ref({})

    async function getOrderListFunc(more) {
        hashLoadingRef.value = true
        if(more) {
            pageRef.value ++
        }else {
            pageRef.value = 0
            orderListRef.value = []
        }
        let data = {
            offset: pageRef.value*pageSizeRef.value,
            limit: pageSizeRef.value,
            status: statusValueRef.value
        }
        let res = await get({url: '/task/v1/task/index',params: data}, {loading: false})
        hashLoadingRef.value = false
        if(res.code != 200) return
        let list = res.data&&res.data.list||[]
        if(list.length&&list.length>=pageSizeRef.value) {
            hashMoreRef.value = true
        }else {
            hashMoreRef.value = false
        }
        orderListRef.value = [...orderListRef.value, ...list]
    }
    async function getCountryDetailFunc(id) {
        let res = await get({url: '/task/v1/task/detail',params: {id: id}}, {loading: true})
        if(res.code != 200) return
        orderDetailRef.value = res.data
    }
    function changeStatusFunc(index) {
        if(statusIndexRef.value != index) {
            statusIndexRef.value = index
            pageRef.value = 0
            orderListRef.value = []
            getOrderListFunc()
        }
    }

    onMounted(()=> {
        if(init) {
            getOrderListFunc()
        }
    })

    return { 
        statusListRef, statusIndexRef, hashMoreRef, hashLoadingRef, orderListRef, orderDetailRef, 
        getOrderListFunc, getCountryDetailFunc, changeStatusFunc
    }
}

export function goodsModel(init) {
    let goodsListRef = ref([])

    async function getGoodsListFunc() {
        let res = await get({url: '/task/v1/goods-list/index'})
        if(res.code != 200) return
        goodsListRef.value = res.data&&res.data.list||[]
    }
    onMounted(()=> {
        if(init) getGoodsListFunc()
    })

    return { goodsListRef, getGoodsListFunc }
}

export function countryModel() {
    let countryListRef = ref([])

    async function getCountryListFunc() {
        let res = await get({url: '/hotel/v1/country/index'})
        if(res.code != 200) return
        countryListRef.value = res.data&&res.data.list||[]
    }
    
    onMounted(()=> {
        getCountryListFunc()
    })

    return { countryListRef, getCountryListFunc }
}

export function hotelModel(init) {
    const route = useRoute()
    let countryIdRef = ref(null)
    let countryNameRef = ref(null)
    let countryCoverRef = ref(null)
    let hotelListRef = ref([])

    async function getHotelListFunc() {
        let res = await get({url: '/hotel/v1/area/index', params: {id: countryIdRef.value}}, {loading: true})
        if(res.code != 200) return
        hotelListRef.value = res.data&&res.data.list||[]
    }
    
    onMounted(()=> {
        countryIdRef.value = route.query&&route.query.id||null
        countryNameRef.value = route.query&&route.query.name||null
        countryCoverRef.value = decodeURI(route.query&&route.query.cover||'')
        if(init) {
            getHotelListFunc()
        }
    })

    return { countryNameRef, countryCoverRef, hotelListRef, getHotelListFunc }
}